export default __webpack_public_path__ + "static/media/1377.44019e96.png";